import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $panels: this.el._$$('.two-tabs-masthead-extension__panel'),
      $tabs: this.el._$$('.two-tabs-masthead-extension__tab')
    };
  }

  addListeners() {
    this.dom.$tabs._on('click', this.handleTabClick.bind(this));
  }

  handleTabClick(e) {
    const $tab = e.currentTarget;
    const $panel = document.getElementById($tab.getAttribute('aria-controls'));

    if ($tab.getAttribute('aria-selected') === 'true') {
      $tab.setAttribute('aria-selected', 'false');
      $panel.setAttribute('aria-hidden', 'true');
    } else {
      this.dom.$tabs.forEach(tab => tab.setAttribute('aria-selected', 'false'));
      $tab.setAttribute('aria-selected', 'true');

      this.dom.$panels.forEach(panel => panel.setAttribute('aria-hidden', 'true'));
      $panel.removeAttribute('aria-hidden');
    }
  }
}

export default Module;
